import React, { createContext, useContext, useState, ReactNode } from 'react'

interface FullscreenContextType {
  isFullscreen: boolean
  toggleFullscreen: () => void
  setFullscreen: (value: boolean) => void
}

const FullscreenContext = createContext<FullscreenContextType | undefined>(undefined)

export const useFullscreen = () => {
  const context = useContext(FullscreenContext)
  if (context === undefined) {
    throw new Error('useFullscreen must be used within a FullscreenProvider')
  }
  return context
}

interface FullscreenProviderProps {
  children: ReactNode
}

export const FullscreenProvider: React.FC<FullscreenProviderProps> = ({ children }) => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  const toggleFullscreen = () => {
    setIsFullscreen(prev => !prev)
  }

  const setFullscreen = (value: boolean) => {
    setIsFullscreen(value)
  }

  return (
    <FullscreenContext.Provider value={{ isFullscreen, toggleFullscreen, setFullscreen }}>
      {children}
    </FullscreenContext.Provider>
  )
}
